// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2UgLl","calendarButtons":"ClockData_calendarButtons__FWTDU"};